// extracted by mini-css-extract-plugin
export var scrollCueStyles = "scrollcue-module--scrollCueStyles--BA92i";
export var scrollText = "scrollcue-module--scrollText--Khl-F";